module.exports = __webpack_public_path__ + "img/badge-most-appointment-keyvue-pink.71bf630f.png";